import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ActionTile } from '../../../../../../ActionTile';
import BrandColorSwatch from './BrandColorSwatch';
import BrandingTile from '../BrandingTile';
import ColorPicker from './ColorPicker';
import { BRANDING_TILES } from '../constants';
import { MARKETING_MEDIA_FIELDS } from '../../../constants';

const { BRAND_COLOR } = BRANDING_TILES;

const BrandColor = ({ brandColor, updateMarketingMedia }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleActionOnClick = () => {
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
  };

  const handleConfirmColor = (color) => {
    updateMarketingMedia({ [MARKETING_MEDIA_FIELDS.BRAND_COLOR]: color });
    closeDialog();
  };

  return (
    <React.Fragment>
      <ColorPicker
        brandColor={brandColor}
        closeDialog={closeDialog}
        handleConfirmColor={handleConfirmColor}
        isOpen={isOpen}
      />

      <BrandingTile title={BRAND_COLOR.TITLE}>
        <ActionTile
          actionText={BRAND_COLOR.ACTION_TEXT}
          actionOnClick={handleActionOnClick}
          iconName="text-color"
          subText={BRAND_COLOR.SUBTEXT}
        >
          {brandColor && <BrandColorSwatch brandColor={brandColor} />}
        </ActionTile>
      </BrandingTile>
    </React.Fragment>
  );
};

BrandColor.propTypes = {
  brandColor: PropTypes.string,
  updateMarketingMedia: PropTypes.func,
};

export default BrandColor;
